<template>
  <div
    v-if="userAgents?.length"
    @click.stop
  >
    <div v-if="userAgents?.length === 1 && userAgents[0]">
      <wui-icon
        class="anchor"
        :name="userAgents[0].icon"
      />
      <div class="tooltip">
        <wui-icon
          :name="userAgents[0].icon"
          :title="userAgents[0].text"
        />
        <span class="text-1316">{{ userAgents[0].text }}</span>
      </div>
    </div>
    <div
      v-else
      class="z-30"
    >
      <wui-dropdown
        direction="bottom"
        close-on-click-outside
        plain
      >
        <template #activator="{ toggle, isActive }">
          <wui-icon
            class="cursor-pointer"
            :class="{ 'rotate-180': isActive }"
            small
            name="expand"
            @click.stop="toggle"
          />
        </template>
        <template #default>
          <wui-card
            state="text"
            shadow="overflow"
          >
            <wui-list>
              <wui-list-item
                v-for="userAgent in userAgents"
                :key="userAgent.text"
              >
                <div class="flex gap-2 items-center text-nowrap">
                  <wui-icon :name="userAgent.icon" />
                  <span>{{ userAgent.text }}</span>
                </div>
              </wui-list-item>
            </wui-list>
          </wui-card>
        </template>
      </wui-dropdown>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconName, WuiCard, WuiDropdown, WuiIcon, WuiList, WuiListItem } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useLocalization } from '@/shared/composables/localization'
import { getUserAgentView } from '@/shared/utils/platform'

import { useStoreContacts } from '..'

const props = defineProps<{
  pServed: string
}>()

const { contactsUserAgents } = storeToRefs(useStoreContacts())
const { t } = useLocalization()

type UserAgent = {
  text: string,
  icon: IconName,
}

const userAgents = computed<UserAgent[]>(() => {
  const result: UserAgent[] = []
  contactsUserAgents.value.get(props.pServed)?.forEach(platform => {
    const view = getUserAgentView(platform)
    if (!view) {
      return
    }

    result.push({
      text: t(view.textKey),
      icon: view.icon,
    })
  })

  return result
})
</script>

<style scoped>
@reference "../../../app/assets/tailwind.css";

.anchor {
  anchor-name: --my-anchor;
  &:hover + .tooltip {
    display: flex;
  }
}

.tooltip {
  @apply gap-2 bg-elev-context-menu-bg p-1 pr-2 text-fg-base-fg3 shadow-overlay rounded-4 z-10;
  position-anchor: --my-anchor;
  position-area: center right;
  display: none;
  align-items: center;
  position: absolute;
}
</style>
